<template>
  <div class="app ma-4">
    <div class="text-h4">Relatórios de Operador</div>
    <v-tabs v-model="tabs" background-color="background" class="fixed-tabs-bar">
      <v-tab v-for="n in tipos" :key="n">
        {{ tipo[n - 1] }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs" class="app">
      <v-tab-item>
        <OperadorResumido />
      </v-tab-item>
      <v-tab-item>
        <OperadorResumidoDireto />
      </v-tab-item>
      <v-tab-item>
        <OperadorResumidoSaida />
      </v-tab-item>
      <v-tab-item>
        <OperadorDetalhado />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import OperadorResumido from '../_components/resumidoOperador/_views/RelatorioResumidoOperador'
import OperadorResumidoDireto from '../_components/resumidoDiretoOperador/_views/RelatorioOperadorDiretoResumido'
import OperadorResumidoSaida from '../_components/resumidoSaidaOperador/_views/RelatorioOperadorDiretoResumido'
import OperadorDetalhado from '../_components/detalhadoOperador/_views/RelatorioDetalhadoOperador'

export default {
  name: 'RelatoriosOperador',
  components: {
    OperadorResumido,
    OperadorResumidoDireto,
    OperadorDetalhado,
    OperadorResumidoSaida,
  },
  data: () => ({
    tabs: 4,
    tipos: 4,
    tipo: ['Resumido Fila', 'Resumido Direto', 'Resumido Saída', 'Detalhado'],
  }),
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}

.fixed-tabs-bar {
  position: -webkit-sticky;
  position: sticky;
  top: 48px;
  z-index: 15;
}
</style>
